<template>
    <div class="col-lg-3 theiaStickySidebar">
        <div class="stickysidebar">
            <div class="filter-clear">
                <div class="clear-filter mb-4 pb-lg-2 d-flex align-items-center justify-content-between">
                    <h5><i class="feather-filter me-2"></i>Filters</h5>
                  <a href="javascript:void(0);" class="clear-text" @click="clearFilters">
                        Clear
                    </a>
                </div>


                  <!-- Course Type Scheduled or Demand -->

                    <div class="accordion-item">
                            <h2 class="accordion-header" id="headingcustomicon1Two">
                                <a href="#" class="accordion-button" data-bs-toggle="collapse" data-bs-target="#collapsecustomicon1Two" aria-expanded="false" aria-controls="collapsecustomicon1Two">
                            Course Type<i class="fa-solid fa-chevron-down"></i>
                                </a>
                            </h2>
                            <div id="collapsecustomicon1Two" class="accordion-collapse collapse show" aria-labelledby="headingcustomicon1Two" data-bs-parent="#accordioncustomicon1Example">
                                <div class="accordion-body">
                                    <div>
                                        <label class="custom_check">
                                        <input type="checkbox" value="Scheduled" v-model="selectedCourseType">
                                           <span class="checkmark"></span> Scheduled 
                                            <!-- Show count ONLY if selected -->
                                            <span v-if="selectedCourseType.includes('Scheduled')">
                                            ({{ scheduledCount }})
                                            </span>


                                        </label>
                                    </div>
                                    <div>
                                        <label class="custom_check">
                                        <input type="checkbox" value="OnDemand" v-model="selectedCourseType">
                                            <span class="checkmark"></span> On-Demand
                                             <!-- Show count ONLY if selected -->
                                            <span v-if="selectedCourseType.includes('OnDemand')">
                                            ({{ onDemandCount }})
                                            </span>

                                        </label>
                                    </div>
                                
                                    
                                </div>
                            </div>
                    </div>

                    

                    <!-- Content Area -->
                        <div class="accordion-item">
                        <h2 class="accordion-header" id="headingcustomicon1Two">
                            <a
                            href="#"
                            class="accordion-button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapsecustomicon1Two"
                            aria-expanded="false"
                            aria-controls="collapsecustomicon1Two"
                            >
                            Content Area<i class="fa-solid fa-chevron-down"></i>
                            </a>
                        </h2>

                        <div
                            id="collapsecustomicon1Two"
                            class="accordion-collapse collapse show"
                            aria-labelledby="headingcustomicon1Two"
                            data-bs-parent="#accordioncustomicon1Example"
                        >
                            <div class="accordion-body">

                            <!-- 🔄 Loader -->
                            <div v-if="loading" class="text-muted small">Loading...</div>

                            <!-- ✅ Dynamic Audience List -->
                            <div v-else>
                                <div
                                v-for="(aud, index) in audiencelist"
                                :key="aud.id"
                                >
                                <label class="custom_check">
                                    <input
                                    type="checkbox"
                                    name="audience"
                                    :value="aud.id"
                                    v-model="selectedAudiences"
                                    />
                                    <span class="checkmark"></span> {{ aud.audience_title }}
                                    <!-- COUNT visible only if THIS audience is selected -->
                                        <span v-if="selectedAudiences.includes(aud.id)">
                                        ({{ getAudienceCount(aud.id) }})
                                        </span>
                                </label>
                                </div>

                                <!-- ❌ No audience found -->
                                <div v-if="audiencelist.length === 0" class="text-muted small">
                                No content areas available.
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>



            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from "vue";
import api from "@/services/api";


const props = defineProps({
  allCourses: { type: Array, default: () => [] }
});

const audiencelist = ref([]);
const loading = ref(true);
const selectedAudiences = ref([]);
const selectedCourseType = ref([]);

 

const emit = defineEmits(["filterChange"]);

const fetchAudiences = async () => {
  loading.value = true;
  try {
    const res = await api.get("/audiencelist");
    if (res.data.success) {
      audiencelist.value = res.data.data;
    }
  } finally {
    loading.value = false;
  }
};

// Convert "1,2" into ["1","2"]
const parseAudience = (val) => {
  if (!val) return [];
  return String(val)
    .split(",")
    .map((s) => s.trim());
};

// 🟢 Dynamic Scheduled Count
const scheduledCount = computed(() => {
  return props.allCourses.filter((c) => {
    const matchType = c.on_demand === "Scheduled";

    if (selectedAudiences.value.length > 0) {
      const auds = parseAudience(c.audience);
      return (
        matchType &&
        selectedAudiences.value.some((sel) => auds.includes(String(sel)))
      );
    }
    return matchType;
  }).length;
});

// 🟢 Dynamic OnDemand Count
const onDemandCount = computed(() => {
  return props.allCourses.filter((c) => {
    const matchType = c.on_demand === "OnDemand";

    if (selectedAudiences.value.length > 0) {
      const auds = parseAudience(c.audience);
      return (
        matchType &&
        selectedAudiences.value.some((sel) => auds.includes(String(sel)))
      );
    }
    return matchType;
  }).length;
});

// 🟣 Dynamic Audience Count Function
const getAudienceCount = (audId) => {
  return props.allCourses.filter((c) => {
    const courseAudiences = parseAudience(c.audience);

    // match audience itself
    const matchAudience = courseAudiences.includes(String(audId));

    // apply Course Type filter if active
    if (selectedCourseType.value.length > 0) {
      if (!selectedCourseType.value.includes(c.on_demand)) return false;
    }

    // apply Audience filter if active
    if (selectedAudiences.value.length > 0) {
      const matchSelected = selectedAudiences.value.some(sel =>
        courseAudiences.includes(String(sel))
      );
      return matchAudience && matchSelected;
    }

    return matchAudience;
  }).length;
};

// Emit changes
watch([selectedCourseType, selectedAudiences], () => {
  emit("filterChange", {
    types: selectedCourseType.value,
    audiences: selectedAudiences.value,
  });
});


const clearFilters = () => {
  selectedCourseType.value = [];
  selectedAudiences.value = [];

  emit("filterChange", {
    types: [],
    audiences: []
  });
};


onMounted(() => {
  fetchAudiences();
});
</script>

